import React from "react";
import { Button } from "@blueprintjs/core";
import "styled-components/macro";
import { useVfOpenModal } from "../store/model-misc";

export function ViewFlopptionsButtonCellRenderer({ value, data }) {
  const openModal = useVfOpenModal();
  return (
    <span>
      <Button
        data-testid={`view_flopptions_button__${data.id}`}
        data-testclass="view_flopptions_button"
        disabled={value <= 1}
        minimal
        small
        large={false}
        intent="primary"
        onClick={() => openModal({ snapshot: data })}
      >
        {value}
      </Button>
    </span>
  );
}
